import React from 'react'
import { usePage } from 'hooks'
import Header from 'components/app/Header'
import PageBody from 'components/app/PageBody'
import CompanyBreadcrumb from 'components/company/CompanyBreadcrumb'
import IntegrationsContainer from 'components/integrations/IntegrationsContainer'
// import IntegrationsHeader from 'components/reports/IntegrationsHeader'

export default function IntegrationsPage() {
  const { header } = usePage()

  return (
    <PageBody
      renderHeader={() => (
        <>
          <Header>
            <CompanyBreadcrumb crumbs={header?.crumbs} />
          </Header>
          {/* <IntegrationsHeader /> */}
        </>
      )}
      renderContent={() => <IntegrationsContainer />}
    />
  )
}
